module.exports = __webpack_public_path__ + "media/images/shin-japanese-79370cd04cc120b3be3aa22159de2f5d.png";